<div class="table-responsive" *ngIf="lojistikler">
  <table class="table card-table table-vcenter text-nowrap datatable">
    <thead>
      <tr>
        <th>Şube</th>
        <th>Tarih</th>
        <th>Cari</th>
        <th class="text-right">Mazot Baz Fiyatı</th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let l of lojistikler">
        <td>{{ l.sube?.isim }}</td>
        <td>{{ l.tarih | date:'dd.MM.yyyy' }}</td>
        <td>{{ l.cari?.firmaUnvani }}</td>
        <td class="text-right">{{ l.mazotBazFiyati.toFixed(2) }} TL</td>
        <td class="text-right">
          <div class="btn btn-sm btn-danger" (click)="sil(l.id)">sil</div>
          <div class="btn btn-sm btn-success ml-2" (click)="incele(l)">İncele</div>
          <div class="btn btn-sm btn-secondary ml-2" (click)="degisimGecmisi(l)">Değişim Geçmişi</div>
          <div class="btn btn-sm btn-primary ml-2" (click)="IrsaliyeFiyat(l.id)">İrsaliyeleri Getir</div>
          <div class="btn btn-sm btn-warning ml-2" (click)="rotaFiyat(l.id)">Rota-Fiyat</div>
        </td>
      </tr>
    </tbody>
  </table>
</div>